import { Fragment, jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Animate, Card } from "pcln-design-system";
import { productsType } from "../../constants/index.js";
import styled_components from "styled-components";
import { TripCard } from "./TripCard.js";
import { getPackageTrips } from "./getPackageTrips.js";
import { myTripContextData } from "./myTripDataContext.js";
import { formatTripMessageContent } from "./formatTripMessageContent.js";
const StyledTripsLinkCard = /*#__PURE__*/ styled_components(Card).withConfig({
    displayName: "MyTripsList__StyledTripsLinkCard"
})([
    "cursor:pointer;"
]);
const MyTripsList = (props)=>{
    const { trips, tripCategory } = props;
    const { deepLinkPrompt, submitChatMessageInMarkerComponent } = useContext(myTripContextData);
    return /*#__PURE__*/ jsx(Fragment, {
        children: trips.sort((a, b)=>new Date(a.travelStartDate).getTime() - new Date(b.travelStartDate).getTime()).map((trip, index)=>{
            const { checkStatusUrl, type } = trip;
            const isPackage = type === productsType.PACKAGE;
            const actualCheckStatusUrl = `${checkStatusUrl}${deepLinkPrompt || ''}`;
            return /*#__PURE__*/ jsx(Animate, {
                variant: 'slideInLeft',
                override: {
                    transition: {
                        delay: 0.1 * index || 0
                    }
                },
                children: /*#__PURE__*/ jsx(StyledTripsLinkCard, {
                    "data-testid": `trip-link-card-${tripCategory}-${index}`,
                    onClick: function(event) {
                        event.preventDefault();
                        if (submitChatMessageInMarkerComponent) submitChatMessageInMarkerComponent({
                            role: 'user',
                            content: formatTripMessageContent(trip)
                        }, []);
                        else window.open(actualCheckStatusUrl);
                    },
                    borderWidth: 0,
                    width: 1,
                    children: /*#__PURE__*/ jsx(TripCard, {
                        trip: isPackage ? getPackageTrips(trip) : trip,
                        actualCheckStatusUrl: actualCheckStatusUrl
                    })
                })
            }, index);
        })
    });
};
export { MyTripsList };
